import { ReactElement, ReactNode } from "react";
import { Helmet, HelmetProps } from "react-helmet-async";

export interface HeadProps extends HelmetProps {
  children: ReactNode;
  includeSuffix?: boolean;
  defaultTitle?: string;
}

export function Head({
  children,
  includeSuffix = true,
  defaultTitle = "Billiant Web",
  ...props
}: HeadProps): ReactElement {
  const template = includeSuffix ? "%s | ".concat(defaultTitle) : "%s";

  return (
    <Helmet titleTemplate={template} defaultTitle={defaultTitle} {...props}>
      {children}
    </Helmet>
  );
}
